// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"Usps_visuallyHidden__vaiqa","stars":"Usps_stars__MPgUD","usps":"Usps_usps__WSVVu","uspItem":"Usps_uspItem__brBEx","spinner":"Usps_spinner__Cmtpd"};